// v2 audio-permission modal — clean white prompt to unlock autoplay audio for
// voice announcements. Auto-allows after a 10s countdown (kiosk-friendly) —
// only the first time it opens: an auto-allow has no user gesture, so if the
// browser still blocks audio the box must then wait for a real press instead
// of re-allowing (and re-opening) every 10s.
import React, { useEffect, useRef, useState } from "react";

let autoAllowUsed = false;

interface Props {
  isOpen: boolean;
  onAllow: () => void;
  onCancel: () => void;
}

const AudioPermissionModal: React.FC<Props> = ({
  isOpen,
  onAllow,
  onCancel,
}) => {
  const [countdown, setCountdown] = useState(10);
  const allowRef = useRef(onAllow);
  allowRef.current = onAllow;

  useEffect(() => {
    if (!isOpen) return;
    if (autoAllowUsed) {
      setCountdown(0);
      return;
    }
    autoAllowUsed = true;
    let n = 10;
    setCountdown(n);
    const id = setInterval(() => {
      n -= 1;
      setCountdown(n);
      if (n <= 0) {
        clearInterval(id);
        allowRef.current();
      }
    }, 1000);
    return () => clearInterval(id);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-[90%] max-w-md rounded-2xl bg-white p-8 text-center shadow-xl">
        <h2 className="text-xl font-semibold text-[#1F2B4D]">
          Enable voice announcements?
        </h2>
        <p className="mt-2 text-sm text-[#7A869A]">
          Allow audio so patient names are called out on this display.
        </p>
        <div className="mt-6 flex gap-3">
          <button
            onClick={onAllow}
            autoFocus
            className="flex-1 rounded-lg bg-[#0B74FF] py-3 font-semibold text-white hover:bg-[#0a66e0]"
          >
            Allow{countdown > 0 ? ` (${countdown})` : ""}
          </button>
          <button
            onClick={onCancel}
            className="flex-1 rounded-lg border border-[#E3E8F0] py-3 font-medium text-[#5A6478] hover:bg-[#F2F5FA]"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

export default AudioPermissionModal;
